import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { studyFactorServices } from "../../../../../APIServices/CTMS/studyFactorServices";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const AddNewSubject = ({
  siteId,
  getStudySiteSubjectList,
  Show,
  Hide,
  Title,
  subjectSettings,
}) => {
  let { studyId } = useParams();
  const [subjectColumns, setSubjectColumns] = useState([]);
  const [subjectRow, setSubjectRow] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [voidSubjectId, setVoidSubjectId] = useState("");
  const [factorArray, setFactorArray] = useState([]);
  const [factorList, setFactorList] = useState([]);
  const [voidSubjectList, setVoidSubjectList] = useState([]);
  const [loader, setLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudySubjectColumnData = async (e) => {
    setLoader(true);
    setSubjectColumns([]);
    let data = await studySubjectManagementServices.getStudySubjectColumnData(
      "active",
      studyId,
      siteId
    );
    let filterColumn = (data?.data || []).filter(
      (item) =>
        item.blinded === "no" &&
        !["SCREENID", "RANDOMNUMBER"].includes(item.columnName)
    );
    setSubjectColumns(filterColumn);
    setLoader(false);
  };

  const handleSubjectRowChange = (e, columnKey) => {
    setSubjectRow({
      ...subjectRow,
      [columnKey]: e.target.value,
    });
  };

  const handleFactorChange = (name, value, index) => {
    setFactorArray((prev) => {
      const updated = [...prev];
      updated[index] = { name, value };
      return updated;
    });
  };

  const addNewStudySubjectRow = async () => {
    setButtonLoader(true)
    let userData = {};
    userData.studyId = studyId;
    userData.siteId = siteId;
    userData.mode = StudyMode;
    userData.subjectRow = subjectRow;
    userData.voidSubjectId = voidSubjectId;
    if (subjectSettings === "IWRS") {
      userData.factorArray = factorArray;
    }
    userData.subjectSettings = subjectSettings;
    let data = await studySubjectManagementServices.addNewStudySubjectRow(
      userData
    );
    if (data?.statusCode === 200) {
      clearForm();
      getStudySiteSubjectList();
    } else {
      setErrorMessage(data?.customMessage);
    }
    setButtonLoader(false)
  };

  const getAssigedFactorinSites = async (e) => {
    let data = await studyFactorServices.getAssigedFactorinSites(
      studyId,
      siteId
    );
    setFactorList(data?.data || []);
  };

  const getTotalVoidSubject = async (e) => {
    let data = await studySubjectManagementServices.getTotalVoidSubject(
      studyId,
      siteId,
      StudyMode
    );
    setVoidSubjectList(data?.data || []);
  };

  const clearForm = () => {
    setSubjectRow("");
    setFactorArray([]);
    setVoidSubjectId("");
  };

  useEffect(() => {
    if (!(siteId === "no" || !siteId)) {
      getStudySubjectColumnData();
      getAssigedFactorinSites();
      getTotalVoidSubject()
      getTotalVoidSubject()
    }
  }, [siteId]);

  function isRowDataComplete() {
    let subjectColumnData = (subjectSettings === "IWRS" || subjectSettings === "Auto") ? subjectColumns?.filter(item => !(item?.columnName === "SUBJECTID")) : subjectColumns
    const requiredColumns = subjectColumnData.filter(
      item => item?.required === "yes"
    );
    return requiredColumns.every(col => {
      const key = col.columnName;
      return subjectRow.hasOwnProperty(key) && subjectRow[key] !== "" && subjectRow[key] !== null && subjectRow[key] !== undefined;
    });
  }

  const isFactorMissing = factorList.some((factor) => {
    return !factorArray.some(
      (item) =>
        item.name === factor.name &&
        item.value !== "" &&
        item.value !== null &&
        item.value !== undefined
    );
  });

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {loader ? (
            <PageLoader />
          ) : (
            <>
              {subjectColumns?.map((item, index) => (
                <Form.Group key={index} className="mb-2">
                  {(subjectSettings === "IWRS" || subjectSettings === "Auto") &&
                    item.columnName === "SUBJECTID" ? (
                    ""
                  ) : (
                    <Form.Label className="fw-bold mb-1">
                      {item?.columnLabel}{" "}
                      {item?.required === "yes" && (
                        <abbr title="Required" className="text-danger"> *</abbr>
                      )}
                    </Form.Label>
                  )}
                  {item?.columnType === "dropdown" ? (
                    <Form.Select
                      onChange={(e) =>
                        handleSubjectRowChange(e, item?.columnName)
                      }
                      className="br3"
                      style={{ fontSize: 12 }}
                    >
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option
                          index={i}
                          selected={subjectRow[item?.columnName] === el?.option}
                          value={el?.option}
                        >
                          {el?.option}
                        </option>
                      ))}
                    </Form.Select>
                  ) : item?.columnType === "radio" ? (
                    (item?.columnOption || [])?.map((el, i) => (
                      <Form.Check
                        key={i}
                        type="radio"
                        label={el?.option}
                        name={item?.columnName}
                        value={el?.option}
                        checked={subjectRow[item?.columnName] === el?.option}
                        onChange={(e) =>
                          handleSubjectRowChange(e, item?.columnName)
                        }
                        className="br3"
                      />
                    ))
                  ) : (subjectSettings === "IWRS" ||
                    subjectSettings === "Auto") &&
                    item.columnName === "SUBJECTID" ? (
                    ""
                  ) : item?.columnType === "date" ? (
                    <Form.Control
                      onChange={(e) =>
                        handleSubjectRowChange(e, item?.columnName)
                      }
                      value={subjectRow[item?.columnName] || ""}
                      className="br3"
                      max={new Date().toISOString().split("T")[0]}
                      placeholder={`Enter ${item?.columnLabel}`}
                      type={item?.columnType}
                    />
                  ) : (
                    <Form.Control
                      onChange={(e) =>
                        handleSubjectRowChange(e, item?.columnName)
                      }
                      value={subjectRow[item?.columnName] || ""}
                      className="br3"
                      placeholder={`Enter ${item?.columnLabel}`}
                      type={item?.columnType}
                    />)}
                </Form.Group>
              ))}
              {subjectSettings === "IWRS" && (
                <>
                  {factorList?.map((item, index) => (
                    <Form.Group className="mb-2" key={index}>
                      <Form.Label className="fw-bold mb-1">
                        {item?.label}{" "}
                        <abbr title="Required" className="text-danger">
                          *
                        </abbr>
                      </Form.Label>
                      <Form.Select
                        value={factorArray[index]?.value || ""}
                        onChange={(e) =>
                          handleFactorChange(item?.name, e.target.value, index)
                        }
                        style={{ fontSize: 12 }}
                        className="br3"
                      >
                        <option value="">Select {item?.label}</option>
                        {(item?.factors || []).map((subItem, subIndex) => (
                          <option key={subIndex} value={subItem?.factor}>
                            {subItem?.option}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  ))}
                </>
              )}
              {voidSubjectList?.length > 0 &&
                <Form.Group className="mb-1">
                  <Form.Label className="fw-bold mb-1">
                    Void Subject (If you want Void Label Subject Screen Id Then Select)
                  </Form.Label>
                  <Form.Select
                    onChange={(e) => setVoidSubjectId(e.target.value)}
                    style={{ fontSize: 12 }}
                    disabled={voidSubjectList?.length === 0}
                    className="br3"
                  >
                    <option selected={voidSubjectId === ""} value="">
                      Select Void Subject
                    </option>
                    {voidSubjectList?.map((item, index) => (
                      <option
                        key={index}
                        selected={voidSubjectId === item?.subjectId}
                        value={item?.subjectId}
                      >
                        {item?.row?.SCREENID}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              }
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            disabled={
              subjectSettings === "IWRS" ?
                (buttonLoader || isFactorMissing || !siteId || !isRowDataComplete())
                :
                (buttonLoader || !siteId || !isRowDataComplete())
            }
            onClick={addNewStudySubjectRow}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              "Add New Subject"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddNewSubject;
